import { Box, Card, CardContent, Typography } from "@mui/material";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { PartConfigurationSchemaProperty } from "src/components/views/erp/configurator/configuratorForm/propertyModel/partConfigurationSdk.ts";

export interface AddPropertyModelSubConfigurationViewProps {
	/** The sub-configuration properties to which a child can be added. */
	properties: PartConfigurationSchemaProperty[];
	addChild: (property: PartConfigurationSchemaProperty) => Promise<unknown>;
}

/** Chooses the sub-configuration to add to a configuration of a property-model tree, as the component form does. */
export function AddPropertyModelSubConfigurationView({
	properties,
	addChild,
}: AddPropertyModelSubConfigurationViewProps) {
	return (
		<Box
			sx={{
				flex: 1,
				display: "grid",
				gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
				alignItems: "stretch",
				gap: 2,
				margin: 2,
			}}
		>
			{properties.map((property) => (
				<Card
					key={property.name}
					sx={{
						border: "1px solid",
						borderColor: "grey.300",
						borderRadius: 2,
						"&:hover": {
							transform: "translateY(-2px)",
							boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
							borderColor: "primary.main",
						},
					}}
				>
					<AsyncButton
						variant={"text"}
						fullWidth
						onClick={() => addChild(property)}
						sx={{ height: "100%", minHeight: 80, borderRadius: 2, textTransform: "none" }}
					>
						<CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
							<Typography
								variant={"body1"}
								sx={{ textAlign: "center", fontWeight: 500, color: "text.primary", lineHeight: 1.3 }}
							>
								{property.title || property.name}
							</Typography>
						</CardContent>
					</AsyncButton>
				</Card>
			))}
		</Box>
	);
}
